export default function CheckOnGreenICon({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width ? width : "53"}
      height={height ? height : "53"}
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="26.5" cy="26.5" r="26.5" fill="#D8F2D4" />
      <path
        d="M15.7339 27.7422L24.0641 36.0724C24.454 36.4623 25.1089 36.3695 25.375 35.8865L36.0229 16.5625"
        stroke="#0F7B1A"
        strokeWidth="3.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
